import * as angular from "angular";
import {PricePlanBundleRequestsService} from "../price-plan/services/price-plan-bundle-requests.service";

angular
  .module('bringoz.admin.depots')
  .config(depotsConfig);

/* @ngInject */
function depotsConfig($stateProvider, moment) {

  $stateProvider

    // Depots
    .state('depots', {
      parent: 'bringoz.site',
      url: '/depots',
      template: '<depots-view></depots-view>',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Depots"});
        triBreadcrumbsService.addCrumb({name: "Operations Management"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    //Depot - Abstract
    .state('depot', {
      parent: 'bringoz.site',
      url: '/depot/:id',
      template: '<depot-details depot="vm.depot"></depot-details>',
      abstract: true,
      controllerAs: 'vm',
      controller: function ($scope, $stateParams, $depots, depot, site) {
        var vm = this;
        vm.depot = depot;
        $depots($stateParams.id).$bindCtrl($scope, vm, 'depot');
      },
      resolve: {
        depot: function ($depots, $stateParams, site) {
          return $depots($stateParams.id).$instantGet();
        }
      }
    })

    .state('depot.shipper-accounts', {
      url: '/shipper-accounts',
      pageTrack: '/depot/shipper-accounts',
      template: '<depot-shipper-accounts-view depot="$ctrl.depot"></depot-shipper-accounts-view>',
      controller: function ($scope, triBreadcrumbsService, depot) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Shipper Accounts"});
        triBreadcrumbsService.addCrumb({name: depot.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Depots", state: "depots"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      }
    })

    .state('depot.branches', {
      url: '/branches',
      pageTrack: '/depot/branches',
      template: '<depot-branches-view depot="$ctrl.depot"></depot-branches-view>',
      controller: function ($scope, triBreadcrumbsService, depot) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Branches"});
        triBreadcrumbsService.addCrumb({name: depot.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Depots", state: "depots"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      }
    })

    .state('depot.agents', {
      url: '/drivers',
      pageTrack: '/depot/drivers',
      template: '<depot-agents-view depot="$ctrl.depot"></depot-agents-view>',
      controller: function ($scope, triBreadcrumbsService, depot) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Drivers"});
        triBreadcrumbsService.addCrumb({name: depot.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Depots", state: "depots"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      }
    })

    .state('depot.schedule', {
      url: '/schedule',
      pageTrack: '/depot/schedule',
      template: '<depot-schedule-view depot="$ctrl.depot" from="vm.from" to="vm.to" programs="vm.programs"></depot-schedule-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, depot, programs) {

        this.from = moment().startOf('week').valueOf();
        this.to = moment().endOf('week').valueOf();
        // this.schedule = schedule
        this.programs = programs;
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Schedule"});
        triBreadcrumbsService.addCrumb({name: depot.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Depots", state: "depots"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      },
      resolve: {
        // schedule: function(depot, programs, scheduleService: ScheduleService) {
        // var from = moment().startOf('week').valueOf();
        // var to = moment().endOf('week').valueOf();
        // return scheduleService.getByDepotId(from, to, depot.id);
        // },
        programs: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService, site) {
          return pricePlanBundleRequestsService.getSitePrograms();
        },
      }
    })

    .state('depot.contact-people', {
      url: '/contact-people',
      pageTrack: '/depot/contact-people',
      template: '<depot-contact-people-view depot="$ctrl.depot"></depot-contact-people-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, depot) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Contact People"});
        triBreadcrumbsService.addCrumb({name: depot.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Depots", state: "depots"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      }
    })

    // Account / Inventory Settings
    .state('depot.inventory-settings', {
      url: '/inventory-settings',
      pageTrack: '/depot/inventory-settings',
      controllerAs: 'vm',
      template: '<depot-inventory-config-view depot="$ctrl.depot"></depot-inventory-config-view>',
      controller: function (depot, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Inventory Settings'});
        triBreadcrumbsService.addCrumb({name: depot.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Depots", state: "depots"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Account / Inventory Settings
    .state('depot.inventory-transactions', {
      url: '/inventory-transactions',
      pageTrack: '/depot/inventory-transactions',
      controllerAs: 'vm',
      template: '<demand-account-inventory-transactions-view account="$ctrl.depot"></demand-account-inventory-transactions-view>',
      controller: function (depot, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Inventory Transactions'});
        triBreadcrumbsService.addCrumb({name: depot.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Depots", state: "depots"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

}
